export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: "AIzaSyAL5VFfQ-vgL5UofCiLb-MLVapjmKKBON8",
    authDomain: "tandem-finance-prd.firebaseapp.com",
    projectId: "tandem-finance-prd",
    storageBucket: "tandem-finance-prd.appspot.com",
    messagingSenderId: "185129279683",
    appId: "1:185129279683:web:06ea1483331d896b578276",
    measurementId: "G-S379X9RRGB"
  },
  environmentName: 'Production',
  stripePublicKey: 'pk_live_51ODUUiEIxj4fplMbNDdOTdbPe71TCDAvBP1hwxpOCngNz4UCOwgWlWj7x23LW1cgWJCX5nDaflclFUVMTFVElscR00PJJ52Vpg',
  functionsPath: 'https://us-central1-tandem-finance-prd.cloudfunctions.net',
  logoPath: 'assets/svg/logo/full_white.svg',
  whiteLogoPath: 'assets/svg/logo/full_white.svg',
  whiteIconPath: 'assets/svg/logo/icon_white.svg',
  primaryIconPath: 'assets/svg/logo/icon_blue.svg',
  defaultTheme: '#4660ea',
  defaultHeaderFont: 'DM Sans',
  defaultBodyFont: 'DM Sans',
  enableGridDisplay: false,
  defaultThemeConfigurationId: 'Ei3UegUkdmWNy8xynNh2iEQnT4z1',
  defaultVideoConfig: {
    userWelcomeRev: 'https://www.youtube.com/embed/HtPZFw1Abvw?si=xqJYiaiV1iETY_A9',
    userWelcomeLead: 'https://www.youtube.com/embed/HtPZFw1Abvw?si=xqJYiaiV1iETY_A9',
    userWelcomeIndividual: 'https://www.youtube.com/embed/HtPZFw1Abvw?si=xqJYiaiV1iETY_A9',
    coachWelcomeRev: 'https://www.youtube.com/embed/3DGwuFAoYqY?si=keArpsAXom9fjO-k',
    coachWelcomeLead: 'https://www.youtube.com/embed/3DGwuFAoYqY?si=keArpsAXom9fjO-k',
    financialPosition: 'https://www.youtube.com/embed/M5kGEj9lKa8?si=wWDxKLBUAkeODQRy',
    cashFlow: 'https://www.youtube.com/embed/ka_eNvEpuvk?si=YJS2BiDP0fJm5DRS',
    spendingPlan: 'https://www.youtube.com/embed/Z3R19NOS4YE?si=wzer92zTSvwzqhfR',
    debtPayoff: 'https://www.youtube.com/embed/KwKJlRyd_Jw?si=VUHUYtx_HDjpJPKs',
    investment: 'https://www.youtube.com/embed/igEfsCtDIPY?si=ywCeEvziyWY00yHp',
    debtVsInvest: 'https://www.youtube.com/embed/he4FNU0683A?si=9qnyVkHONp5JBc0n',
    branding: 'https://www.youtube.com/embed/nk3URZrsi5k?si=2sKvuYZBhLaxn3KO'
  },
  defaultFPid: 'c0d1ODgGqXA5hXYzz658',
  defaultCFid: 'us0U2IKNMlw3Dsh1z8GY',
  defaultSPid: 'MZ1YGXKiQPsElc6U8mYp',
  defaultDomain: 'https://platform.tandemfinance.app',
  defaultCoachId: 'IcXHqfgyz0TJKoTNWHg1GRBOqd23',
  googleFontAPIKey: 'AIzaSyC78zxgzMm4TZJ938i6XOwdHczOcMTngC0',
  /** Browser key with Maps JavaScript API + Places API (New) enabled (for address autocomplete). */
  googleMapsApiKey: 'AIzaSyBiMpGrpnNwv4ayGnUQ_aNjh1mI7vCiJdM',
};
